import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API, errMsg, timeAgo } from "@/lib/api";
import { Page } from "@/components/layout/AppShell";

const appealApi = () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${sessionStorage.getItem("tt_appeal") || ""}` } });

export default function Suspended() {
  const nav = useNavigate();
  const [d, setD] = useState<any>(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!sessionStorage.getItem("tt_appeal")) { nav("/login"); return; }
    appealApi().get("/appeals/me").then((r) => setD(r.data)).catch(() => { sessionStorage.removeItem("tt_appeal"); nav("/login"); });
  }, []);
  const send = async () => {
    setBusy(true);
    try { const { data } = await appealApi().post("/appeals", { note }); setD({ ...d, appeal: data.appeal }); toast.success("Appeal sent — a moderator will review it."); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!d) return <Page className="max-w-xl"><div className="card-tactile h-48 animate-pulse" /></Page>;
  const a = d.appeal;
  const pending = a?.status === "open";
  const rejected = a && a.status !== "open" && a.action === "reject";
  return (
    <Page className="max-w-xl py-12" >
      <p className="eyebrow mb-3">Account suspended</p>
      <h1 className="text-4xl sm:text-5xl font-semibold leading-none" data-testid="suspended-title">{d.name ? `${d.name}, your` : "Your"} account is paused.</h1>
      <div className="card-tactile p-5 mt-8 border-l-2 border-l-[#581C25]" data-testid="suspension-reason"><p className="eyebrow">Moderator note</p><p className="text-sm mt-1">{d.reason}</p></div>

      {!d.restricted ? <div className="card-tactile p-5 mt-4" data-testid="appeal-reinstated"><p className="serif text-xl">Good news — your account is active again.</p><button onClick={() => { sessionStorage.removeItem("tt_appeal"); nav("/login"); }} className="btn-wine mt-4">Sign in</button></div>
      : pending ? <div className="card-tactile p-5 mt-4" data-testid="appeal-pending"><p className="eyebrow !text-[#A36B18]">Appeal pending</p><p className="serif text-xl mt-1">Sent {timeAgo(a.created_at)} ago. A moderator will review it soon.</p><p className="text-sm text-[#5E5C56] mt-2 italic">“{a.reason}”</p></div>
      : <div className="card-tactile p-5 mt-4 space-y-3" data-testid="appeal-form">
          {rejected && <p className="mono text-xs text-[#581C25]" data-testid="appeal-rejected">Your previous appeal ({timeAgo(a.resolved_at)} ago) was rejected{a.note ? `: ${a.note}` : "."} You can send one more.</p>}
          <p className="eyebrow">Your appeal</p>
          <p className="serif text-lg italic">“{d.default_message}”</p>
          <textarea className="input-ed" rows={3} placeholder="Add context (optional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="appeal-note" />
          <button onClick={send} disabled={busy} className="btn-wine w-full sm:w-auto" data-testid="appeal-send">Send appeal</button>
        </div>}
      <button onClick={() => { sessionStorage.removeItem("tt_appeal"); nav("/"); }} className="btn-ghost !py-2 text-xs mt-6" data-testid="appeal-back">Back to Shufflar</button>
    </Page>
  );
}
